import { Alert, Box, Button, Chip, Typography } from '@mui/material';
import TaskTrackingService from '../../services/TaskTrackingService';
import { attentionLabel, BLOCK_REASONS, reasonLabel, startFailedLine, videoProcessingLine } from './taskUi';

// Reasons the PM can dismiss; Unassigned clears by assigning, Overdue/Blocked by acting
const RESOLVABLE = [
    'FLAGGED',
    'REGRESSED',
    'EDITOR_AHEAD',
    'LANGUAGE_REMOVED',
    'CONTENT_DELETED',
    'SYNC_FAILED',
    'EDITOR_SUBMIT_FAILED',
];

/** What needs attention, above everything else. Unblock sits here so a PM not on the step has it too. */
const TaskWarnings = ({ task, detail, perms, current, busy, onStartAgain, openDialog, runOrShow }) => {
    const v = () => ({ version: task.version });
    const videoFailed = detail.startedVideo?.status === 'FAILED';
    const videoProcessing = !!detail.startedVideo && !videoFailed && !detail.startedVideo.ready;
    const blocked = current?.status === 'BLOCKED';
    return (
        <>
            {videoProcessing && (
                <Typography role="status" variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>
                    {videoProcessingLine(detail.startedVideo)}
                </Typography>
            )}
            {videoFailed && (
                <Alert
                    severity="error"
                    sx={{ mt: 1.5 }}
                    action={
                        perms.canManage && (
                            <Button color="inherit" size="small" onClick={onStartAgain}>
                                Start video translation again
                            </Button>
                        )
                    }
                >
                    {startFailedLine(detail.startedVideo)}
                </Alert>
            )}
            {(task.attentionReasons || []).length > 0 && (
                <Box sx={{ mt: 1.5, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {task.attentionReasons.map((r) => (
                        <Chip
                            key={r}
                            color="warning"
                            size="small"
                            label={attentionLabel(r, null, task)}
                            onDelete={
                                perms.canManage && RESOLVABLE.includes(r)
                                    ? () =>
                                          openDialog({
                                              usageName: 'TaskResolveDialog',
                                              title: `Resolve: ${attentionLabel(r)}`,
                                              submitLabel: 'Resolve',
                                              fields: [{ name: 'note', label: 'Note (optional)', multiline: true }],
                                              submit: (vals) =>
                                                  TaskTrackingService.resolveAttention(task.id, {
                                                      ...v(),
                                                      reason: r,
                                                      note: vals.note,
                                                  }),
                                          })
                                    : undefined
                            }
                        />
                    ))}
                </Box>
            )}
            {task.overallStatus === 'ON_HOLD' && task.holdReason && (
                <Alert severity="info" sx={{ mt: 1.5 }}>
                    On hold: {task.holdReason}
                </Alert>
            )}
            {(task.blockedReason || blocked) && (
                <Alert
                    severity="error"
                    sx={{ mt: 1.5 }}
                    action={
                        perms.canBlock &&
                        blocked && (
                            <Button
                                color="inherit"
                                size="small"
                                disabled={busy}
                                onClick={() => runOrShow(() => TaskTrackingService.unblock(task.id, v()))}
                            >
                                Unblock
                            </Button>
                        )
                    }
                >
                    {task.blockedReason ? `Blocked: ${reasonLabel(BLOCK_REASONS, task.blockedReason)}` : 'Blocked'}
                </Alert>
            )}
        </>
    );
};

export default TaskWarnings;
